// antd table
import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "@reach/router";
import { Table, Tag } from "antd";

import { dashboardActions } from "../../../_actions/dashboard.actions";
import { appNotification } from "../../../_components";

const DataTable = ({ filterValues, page, setPage }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMounted = useRef(false);

  const { terminalSummaryData, isLoading, error, summaryCount } = useSelector(
    (state) => state.dashboardState
  );

  const { getTerminals } = dashboardActions;

  const pagination = {
    total: summaryCount,
    pageSize: 10,
    showSizeChanger: false,
    current: page,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    onChange: (page) => {
      setPage(page);
      // dispatch(getTerminals(page));
    },
  };

  useEffect(() => {
    if (error) {
      appNotification(
        error.errorMessage,
        "Unable to get terminal summary",
        "error"
      );
    }
    if (!isMounted.current) {
      dispatch(getTerminals(1));
      isMounted.current = true;
    }
  });

  const columns = [
    {
      title: "Case ID",
      dataIndex: "caseId",
      key: "caseId",
    },
    {
      title: "Record Count",
      dataIndex: "recordCount",
      key: "recordCount",
    },
    {
      title: "Success Count",
      dataIndex: "successCount",
      key: "successCount",
    },
    {
      title: "Failed Count",
      dataIndex: "failedCount",
      key: "failedCount",
    },
    {
      title: "Date Created",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (text) => {
        return (
          <span>
            {new Date(text).toLocaleDateString()}{" "}
            {new Date(text).toLocaleTimeString()}
          </span>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        let color = "green";
        if (text === "FAILED") {
          color = "red";
        } else if (text === "PENDING") {
          color = "orange";
        }
        return (
          <Tag
            style={{
              textTransform: "uppercase",
              width: "5rem",
              textAlign: "center",
            }}
            color={color}
          >
            {text}
          </Tag>
        );
      },
    },
  ];
  return (
    <div>
      <Table
        rowKey={(record) => record.id}
        columns={columns}
        dataSource={terminalSummaryData}
        pagination={pagination}
        scroll={{ x: "max-content" }}
        loading={isLoading}
      />
    </div>
  );
};

export default DataTable;
